import Splide from "@splidejs/splide";

function initSlider() {
  document.querySelectorAll(".splide").forEach(function (slider) {
    new Splide(slider, {
      type: "slide",
      perPage: 1,
      arrows: true,
      pagination: false,
      gap: "24px",
    }).mount();
  });
}

if (document.querySelectorAll(".splide")) {
  initSlider();
}
